export class Specialite {
    readonly id: number;
    name: string;
}

export const enum SpecialiteName {
    Mecanique = 'MECANIQUE',
    Electricite = 'ELECTRICITE',
    Menuiserie = 'MENUISERIE'
}
